import { FormClassifiedInfo } from '~/models/classified/form'
import { EditState } from './state'
import { MutationTree } from 'vuex'
import {
  SET_CATEGORY,
  SET_INFO,
  SET_INFO_AUTO_TOUCH,
  SET_MARKETPLACE,
  SET_OWNER,
  SET_REGISTER_REFERENCE_CODE,
  RESET_EDIT_STATE
} from './mutation-types'
import { Dealer } from '~/models/dealer/types'
import { ClassifiedEditMarketplaceInfo } from '~/models/classified/edit'
import { AutoTouchSchedule } from '~/models/auto-touch/types'
import { vue3Set } from '~/utils/nuxt3-migration'
import defaultFormState from '~/store/modules/shared/classifieds/edit/state'

export default {
  [SET_INFO](state, info: FormClassifiedInfo) {
    state.info = info
  },
  [SET_INFO_AUTO_TOUCH](
    state,
    autoTouchData: Partial<AutoTouchSchedule> | null
  ) {
    if (!state.info) {
      return
    }

    vue3Set(state.info, 'autoTouch', autoTouchData)
  },
  [SET_OWNER](state, owner: Dealer) {
    state.owner = owner
  },
  [SET_CATEGORY](state, category: any) {
    state.category = category
  },
  [SET_REGISTER_REFERENCE_CODE](state, registerReferenceCode: string) {
    state.registerReferenceCode = registerReferenceCode
  },
  [SET_MARKETPLACE](state, marketplace: ClassifiedEditMarketplaceInfo) {
    state.marketplace = marketplace
  },
  [RESET_EDIT_STATE](state) {
    Object.assign(state, defaultFormState())
  }
} as MutationTree<EditState>
